import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../components/AccountContext';
import {
  CREATE_ESSENTIAL_ACCOUNT_INVITATION_MUTATION,
  CREATE_ESSENTIAL_ACCOUNT_INVITATION_QUERY,
} from '../services/create-essential-account-invitation.service';
import { Loading } from '../../../components/Loading';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { growlErrors } from '../../../utils/NotificationUtil';
import {
  buildInitialValuesForCreateEssentialAccountInvitationForm,
  buildValidationSchemaForCreateEssentialAccountInvitationForm,
  DEFAULT_STATE,
  extractInput,
} from '../helpers/create-essential-account.helper';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Panel } from 'primereact/panel';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import CreateEssentialAccountInvitationForm from '../components/CreateEssentialAccountInvitationForm';
import { notificationMessages } from '../../../i18n/common';

const messages = defineMessages({
  panelHeader: {
    id: 'accounts.create-essential-account-invitation.header',
    defaultMessage: 'Add Essential account invitation',
  },
});

const CreateEssentialAccountInvitation = () => {
  const [createInvitationData, setCreateInvitationData] = useState(DEFAULT_STATE);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const history = useHistory();
  const { formatMessage } = useIntl();

  const { loading, error, data } = useQuery(CREATE_ESSENTIAL_ACCOUNT_INVITATION_QUERY, {
    variables: {
      partnerId: currentAccount,
    },
  });
  const [createEssentialAccountInvitation] = useMutation(CREATE_ESSENTIAL_ACCOUNT_INVITATION_MUTATION);

  useEffect(() => {
    if (!!data && !!data.account && !!data.activeLocales && !!data.availableNumbersOfEmployees) {
      setCreateInvitationData({
        activeLocales: data.activeLocales,
        availableNumbersOfEmployees: data.availableNumbersOfEmployees,
        account: data.account,
      });
    }
  }, [data]);

  if (error) {
    growlErrors(growl, error);
  }

  if (loading || createInvitationData === DEFAULT_STATE) {
    return <Loading />;
  }

  const initialValues = buildInitialValuesForCreateEssentialAccountInvitationForm(
    currentAccount,
    createInvitationData.account.type,
  );
  const validationSchema = buildValidationSchemaForCreateEssentialAccountInvitationForm();

  const handleSubmit = async (values) => {
    const input = extractInput(values, currentAccount);

    try {
      await createEssentialAccountInvitation({
        variables: {
          input,
        },
      });
      growl.show({ severity: 'info', detail: formatMessage(notificationMessages.success) });
      history.push(`/accounts/${currentAccount}/accounts/invitations`);
    } catch (err) {
      growl.show({ severity: 'error', detail: err.message, sticky: true });
    }
  };

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel header={formatMessage(messages.panelHeader)}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              <CreateEssentialAccountInvitationForm createInvitationData={createInvitationData} />
            </Formik>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default CreateEssentialAccountInvitation;
